import React,{useEffect,useRef} from 'react';
import {createPortal} from 'react-dom';
import Modal from '../ui/Modal';
import './MarketingDialog.css';
export default function MarketingDialog({open,onClose,className='',...props}) {
  const root=useRef(null),close=useRef(onClose);close.current=onClose;
  useEffect(()=>{
    if(!open)return;
    const previous=document.activeElement,dialog=root.current?.querySelector('[role="dialog"]');
    dialog?.setAttribute('tabindex','-1');dialog?.focus();
    const keyboard=e=>{
      if(e.key==='Escape'){e.preventDefault();e.stopPropagation();close.current();}
      if(e.key==='Tab') {
        const controls=Array.from(root.current.querySelectorAll('button:not(:disabled),input:not(:disabled),a[href]'));
        const first=controls[0],last=controls[controls.length-1];
        if(e.shiftKey&&(document.activeElement===first||document.activeElement===dialog)){e.preventDefault();last?.focus();}
        else if(!e.shiftKey&&(document.activeElement===last||document.activeElement===dialog)){e.preventDefault();first?.focus();}
      }
    };
    dialog?.addEventListener('keydown',keyboard);
    return()=>{dialog?.removeEventListener('keydown',keyboard);if(previous?.isConnected)previous.focus();};
  },[open]);
  return open?createPortal(<div ref={root} className={'marketing-dialog '+className}><Modal {...props} open={open} onClose={onClose}/></div>,document.body):null;
}
